import './index.css';

import * as environment from './environment.json';
import { v4 } from 'uuid';

addEventListener("DOMContentLoaded", onDOMContentLoaded);

function onDOMContentLoaded(event) {
    ensureUserExists();

    getCountData()
        .then((data) => {
            updateCounts(data);
            markAsLoaded();
        });

    document.querySelector('form#count-me')
            .addEventListener('submit', submitCount);

    document.querySelectorAll('.chabura > form')
            .forEach(ele => ele.addEventListener('submit', submitChaburaCode));

    document.querySelectorAll('.chabura .icon.folder')
            .forEach(ele => ele.addEventListener('click', toggleFolder));

    document.querySelectorAll('.media .tab')
            .forEach(tabElement => tabElement.addEventListener('click', (evt) => onMediaTabClicked(evt.target)));

    // document.getElementById('open-shiur')
    //         .addEventListener('click', navigateToShiur);

    // document.getElementById('close-dialog')
    //         .addEventListener('click', closeDialog);

    // document.getElementById('open-video')
    //         .addEventListener('click', navigateToShiur);

    // if (localStorage.getItem('hopeful never hopeless dialog dismissed') !== 'true') {
    //     document.querySelector('#dialog').showModal();
    // }

    var footerElement = document.querySelector('footer');
    footerElement.innerHTML = footerElement.innerHTML.replace('{{year}}', `2023 - ${new Date(Date.now()).getFullYear()}`);

    insertTestimonials();
    showFeedback();
    setupFeedbackCarouselEventHandlers();
}

function closeDialog() {
    document.querySelector('#dialog').close();
    localStorage.setItem('hopeful never hopeless dialog dismissed', 'true');
}

function navigateToShiur() {
    document.getElementById('media')
            .scrollIntoView({
                behavior: 'smooth'
            });
    onMediaTabClicked(document.querySelector('.media .tab[data-section="resources"]'));
}

function onMediaTabClicked(element) {
    document.querySelectorAll('.media section')
            .forEach(section => {
                if (section.classList.contains(element.dataset['section'])) {
                    section.classList.remove('inactive');
                } else {
                    section.classList.add('inactive');
                }
            });

    document.querySelectorAll('.media .tab')
            .forEach(tab => {
                if (tab.dataset['section'] === element.dataset['section']) {
                    tab.classList.add('active');
                } else {
                    tab.classList.remove('active');
                }
            });
}

var submittingCount = false;

function submitCount(evt) {
    const request = () => postCountDataFetchRequest().then((data) => updateCounts(data));
    showIndicatorButton(evt, request, submittingCount, (newValue) => submittingCount = newValue);
}

function markAsLoaded() {
    document.querySelector('form button')
            .removeAttribute('disabled');
    document.querySelector('section.counters')
            .classList.remove('loading');
}

function updateCounts(countsData) {
    updateCount('day', countsData.daily);
    updateCount('week', countsData.weekly);
    updateCount('all', countsData.allTime);
}

function updateCount(id, count) {
    var counterElement = document.querySelector(`.counter.${id}`)
                                    .querySelector('span');
    counterElement.innerText = count || 0;
}

function getCountDataFetchRequest() {
    return fetch(
        `${environment.baseApiUri}/api/amida?date=${encodeURIComponent(toIsoString(new Date(Date.now())))}`,
        {
            headers: { 'PD_AUTH': getUserProfile().id },
            method: 'GET'
        }
    )
    .then(
        (response) => response.json()
    );
}

function getCountData() {
    return performHttpRequestWithRetry(getCountDataFetchRequest);
}

function postCountDataFetchRequest() {
    return fetch(
        `${environment.baseApiUri}/api/amida-new`,
        {
            headers: { 'PD_AUTH': getUserProfile().id },
            method: 'POST',
            body: JSON.stringify({
                date: toIsoString(new Date(Date.now()))
            })
        }
    )
    .then(
        (response) => response.json()
    );
}

function toIsoString(date) {
    var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            return (num < 10 ? '0' : '') + num;
        };

    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) +
        dif + pad(Math.floor(Math.abs(tzo) / 60)) +
        ':' + pad(Math.abs(tzo) % 60);
}

function ensureUserExists() {
    let userProfileString = localStorage.getItem('User Profile');
    if (userProfileString === 'null' || userProfileString === null) {
        localStorage.setItem('User Profile', JSON.stringify({ id: v4() }));
    }
}

function getUserProfile() {
    return JSON.parse(localStorage.getItem('User Profile'));
}

function insertTestimonials() {
    const testimonialsElement = document.querySelector('.testimonials');

    testimonials.forEach(testimonial => {
        const testimonialElement = document.createElement('div');
        testimonialElement.classList.add('testimonial');

        const videoElement = document.createElement('video');
        videoElement.setAttribute('controls', '');
        videoElement.setAttribute('preload', 'none');
        videoElement.setAttribute('poster', `assets/${testimonial.filename}.png`);

        const sourceElement = document.createElement('source');
        sourceElement.setAttribute('src', `https://amidaarmy.blob.core.windows.net/testimonials/${testimonial.filename}.mp4`);
        sourceElement.setAttribute('type', 'video/mp4');

        const titleElement = document.createElement('h4');
        titleElement.textContent = testimonial.title;

        const subtitleElement = document.createElement('h6');
        subtitleElement.textContent = testimonial.subtitle;

        videoElement.appendChild(sourceElement);
        testimonialElement.appendChild(videoElement);
        testimonialElement.appendChild(titleElement);
        testimonialElement.appendChild(subtitleElement);

        testimonialsElement.appendChild(testimonialElement);
    });
}

var submittingChaburaCode = false;
function submitChaburaCode(evt) {
    const request = () => postWeeklyChaburaCode(
        evt.srcElement.querySelector('input.series-id').value,
        evt.srcElement.querySelector('input.code').value
    )
    .then((data) => {
        if (data?.shiurim?.length > 0) {
            insertChabura(evt.srcElement, data);
        }
    });

    showIndicatorButton(evt, () => request(), submittingChaburaCode, (newValue) => submittingChaburaCode = newValue);
}

function toggleFolder(evt) {
    if (evt.srcElement.classList.contains('closed')) {
        const h4Element = evt.srcElement.parentElement;
        const hiddenIcon = h4Element.querySelector('.icon.folder.hide');
        const seriesId = h4Element.dataset['seriesId'];
    
        postWeeklyChaburaCode(seriesId)
        .then((data) => {
            if (data?.shiurim?.length > 0) {
                hiddenIcon.classList.remove('hide');
                evt.srcElement.classList.add('hide');
                insertChabura(h4Element.parentElement.querySelector('section'), data);
            }
        });
    }
}

function insertChabura(formElement, chabura) {
    const chaburaElement = formElement.parentElement;
    chaburaElement.removeChild(formElement);

    chabura.shiurim.forEach(shiur => {
        const shiurElement = document.createElement('div');
        shiurElement.classList.add('shiur');

        const videoElement = document.createElement('video');
        videoElement.setAttribute('controls', '');
        videoElement.setAttribute('preload', 'none');
        videoElement.setAttribute('poster', `assets/${shiur.location}.png`);

        const sourceElement = document.createElement('source');
        sourceElement.setAttribute('src', `https://amidaarmy.blob.core.windows.net/chaburas/${shiur.location}.mp4`);
        sourceElement.setAttribute('type', 'video/mp4');

        const titleElement = document.createElement('h4');
        titleElement.textContent = shiur.title;

        videoElement.appendChild(sourceElement);
        shiurElement.appendChild(videoElement);
        shiurElement.appendChild(titleElement);

        chaburaElement.appendChild(shiurElement);
    });
}

function submitWeeklyChaburaCodeRequest(seriesId, code) {
    let baseUri = `${environment.baseApiUri}/api/passcode?seriesId=${seriesId}`;
    if (code) {
        baseUri = `${baseUri}&code=${code}`;
    }
    return fetch(
        baseUri,
        {
            headers: { 'PD_AUTH': getUserProfile().id },
            method: 'POST'
        }
    )
    .then(
        (response) => {
            if (response.status === 200) {
                return response.json();
            }

            throw Error();
        }
    );
}

function postWeeklyChaburaCode(seriesId, code) {
    return performHttpRequestWithRetry(() => submitWeeklyChaburaCodeRequest(seriesId, code));
}

function showIndicatorButton(evt, func, alreadyProcessing, alreadyProcessingUpdater) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    evt.stopPropagation();

    if (!alreadyProcessing) {
        alreadyProcessingUpdater(true);

        const buttonElement = evt.srcElement.querySelector('button');
        const buttonContent = buttonElement.innerHTML;
        buttonElement.innerHTML = `<div class="loader loader--style6" title="5">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                <rect x="0" y="13" width="4" height="5" fill="#fff">
                    <animate attributeName="height" attributeType="XML"
                    values="5;21;5" 
                    begin="0s" dur="0.6s" repeatCount="indefinite" />
                    <animate attributeName="y" attributeType="XML"
                    values="13; 5; 13"
                    begin="0s" dur="0.6s" repeatCount="indefinite" />
                </rect>
                <rect x="10" y="13" width="4" height="5" fill="#fff">
                    <animate attributeName="height" attributeType="XML"
                    values="5;21;5" 
                    begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                    <animate attributeName="y" attributeType="XML"
                    values="13; 5; 13"
                    begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                </rect>
                <rect x="20" y="13" width="4" height="5" fill="#fff">
                    <animate attributeName="height" attributeType="XML"
                    values="5;21;5" 
                    begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                    <animate attributeName="y" attributeType="XML"
                    values="13; 5; 13"
                    begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                </rect>
                </svg>
            </div>`;

        func()
            .finally(() => {
                buttonElement.innerHTML = buttonContent;
                alreadyProcessingUpdater(false);
            });
    }
}

function performHttpRequestWithRetry(request) {
    return request()
        .catch(
            () => new Promise((resolve, reject) => {
                setTimeout(() => resolve(request().catch(reject)), 500)
            })
        );
}

var feedbackCarouselIsPaused = false;
var currentFeedbackIndex = 0;
function showFeedback() {
    const feedbackItem = feedback[currentFeedbackIndex];
    setFeedback(feedbackItem);

    setTimeout(
        () => {
            if (!feedbackCarouselIsPaused) {
                const feedbackItem = feedback[currentFeedbackIndex];

                setFeedback(feedbackItem);
    
                if (currentFeedbackIndex < feedback.length - 1) {
                    currentFeedbackIndex++;
                } else {
                    currentFeedbackIndex = 0;
                }
            }
            showFeedback();
        },
        15000
    );
}

function setupFeedbackCarouselEventHandlers() {
    const feedbackElement = document.getElementById('feedback');
    const pauseIcon = feedbackElement.querySelector('.icon.pause');
    const playIcon = feedbackElement.querySelector('.icon.play');

    pauseIcon.addEventListener('click', () => {
        playIcon.classList.remove('hide');
        pauseIcon.classList.add('hide');
        feedbackCarouselIsPaused = true;
    });

    playIcon.addEventListener('click', () => {
        playIcon.classList.add('hide');
        pauseIcon.classList.remove('hide');
        feedbackCarouselIsPaused = false;
    });

    feedbackElement.querySelector('.icon.forward')
                    .addEventListener('click', () => {
                        currentFeedbackIndex = getNextFeedbackIndex();
                        setFeedback(feedback[currentFeedbackIndex]);
                    });
    feedbackElement.querySelector('.icon.backward')
                    .addEventListener('click', () => {
                        currentFeedbackIndex = getPreviousFeedbackIndex();
                        setFeedback(feedback[currentFeedbackIndex]);
                    });
}

function getNextFeedbackIndex() {
    if (currentFeedbackIndex < feedback.length - 1) {
        return currentFeedbackIndex + 1;
    } else {
        return 0;
    }
}

function getPreviousFeedbackIndex() {
    if (currentFeedbackIndex === 0) {
        return feedback.length - 1;
    } else {
        return currentFeedbackIndex - 1;
    }
}

function setFeedback(feedbackItem) {
    const feedbackElement = document.getElementById('feedback');
    const blockQuoteElement = feedbackElement.querySelector('blockquote')
    blockQuoteElement.innerText = feedbackItem.quote;

    const endQuoteElement = document.createElement('span');
    endQuoteElement.id = 'end-quote';
    feedbackElement.querySelector('blockquote').appendChild(endQuoteElement);

    const pElement = document.createElement('p');

    const nameElement = document.createElement('span');
    nameElement.className = 'name';
    nameElement.innerText = feedbackItem.name || 'anonymous';
    pElement.appendChild(nameElement);

    if (feedbackItem.description) {
        const descriptionElement = document.createElement('span');
        descriptionElement.className = 'description';
        descriptionElement.innerText = feedbackItem.description || '';
        pElement.appendChild(descriptionElement);
    }

    blockQuoteElement.appendChild(pElement);
}

const feedback = [
    {
        quote: `I wanted to share an Amida Army story. My brother is in the reserves and was called into Lebanon on erev Rosh Hashanah. He is the tank driver for his unit. On Shabbos he was sent into Lebanon. The ground beneath the tank gave out and the tank flipped. When this happens there are usually casualties. Feeling the tank shake, the two soldiers on top of the tank immediately grabbed onto something. Additionally, right before the tank flipped, my brother changed his position slightly. BH, there were not only no casualties, but only one soldier was slightly injured and was released from the hospital right away. After Shabbos ended in America he called my mother to ask what time she normally says Tehillim with her friends. She answered that because Shabbos is ending earlier, they now say Tehillim around 5:30 pm central time which is 1:30 am in Israel. He remarked that that is the exact time that the tank flipped. After telling me the story, it occurred to me that it was 6:30 pm Eastern time just as I was finishing to daven mincha! Chasdei Hashem!`
    },
    {
        quote: `Thank you for all that you are doing here with The Amida Army. I feel extremely proud and lucky to be a part of this incredible community. Davening has never been easy for me. I didn’t come from a religious home and, although I did attend a conservative Jewish day school for a few years and go to Jewish camp, I never really got the gist of what I was praying. The Hebrew is difficult if you didn’t grow up with it. Davening at school was taught with what to say and what to do but not with what anything meant. I was uncomfortable davening in English because it felt more church-like in my eyes. Once my father was nifter I stopped davening altogether. I was so angry at Hashem I just couldn’t even talk to him. Slowly over the years I have begun speaking to Hashem in my own words. Once October 7th hit, I had no choice anymore. This wasn’t about me and my relationship with Hashem. It was about my entire world, my entire extended family, and my entire existence. How could I not beseech Hashem to help all of my family spiritually, emotionally and physically. I truly believe with all of my heart that Hashem knows what’s in my heart and my soul. No matter what language I use, it makes no difference. The change for me now is that davening, even though I don’t understand everything I say, has become a comfort to me as well as a praising and a requesting. It is a reminder that Hashem has always been there for me even when I didn’t see it. Though I don’t understand everything I read while I am davening, I also don’t understand everything that happens in the world. The one thing I know I can count on is knowing Hashem is there. I don’t even understand that very well. I just feel it in my soul. The amida army has helped in many ways as well. From learning about  each Bracha to knowing there are so many women like me davening the amida for such an important purpose. I feel  there are others like me that are counting on me to be a part of the army just as I count on them as well. I know if I miss a day, someone has my back just as I have theirs. Gd willing, we will all be zocheh to see the coming of Mashiach bimheyrah beyameinu.`,
        name: `Wendy`,
        description: `from Highland Park, NJ`
    },
    {
        quote: `My acquaintance is Ohad Ben Ami’s cousin. Ohad was with his wife Raz on October 7th and both were taken hostage. While Raz was released in the November cease-fire, Ohad is still in captivity. I saw my acquaintance this past Motsei Shabbat and I told him I’d write to the organizers of the Amida Army to ask if we could dedicate a Shemona Esrei day to Ohad sooner than later. But I didn’t have time to proactively ask anyone to bump him up in the list - I just woke up to Sunday’s dedication having been set for Ohad Ben Ami (Ohad ben Esther) through divine orchestration. AND I just noticed the post to pray for him arrived at 6:13 AM Pacific to the group. This group continues to show me proof of HaShem’s closeness in our lives.`
    },
    {
        quote: `I am such a fan of Amida Army! I was sharing over with a friend about how it has changed my life and enabled me to get back into a habit of saying shemona esrei almost every day. It’s a lot having to do with pushing that big orange button that confirmed that I said it! It seems funny to say because of course I would want to say it for the hostages and chayalim, yet this orange button gives a satisfying experience when the numbers all increase by one. I see my one shemona esrai made a big difference!! Professionally, I do a lot of work related to behavioral economics or behavior change and wow wow wow, I am so amazed at how well you ladies made this experience to positively change my behavior (and my neshama)! Very soon we should be saying shemona esrei, singing, and dancing, praising Hashem for the release of the hostages and the success of the chayalim and welcoming Moshiach! Kol hakavod and a huge THANK YOU for starting the amida army!!`
    },
    {
        quote: `I was delighted to see your letter to the editor in Mishpacha this week. I've joined the group WhatsApp and listened to Rabbi Nissel's fantastic shiur, and I am be'H gearing up to daven my first shemoneh esrei in many many many months. Cannot thank you enough for starting this initiative...I'm personally hoping it will help me develop a new "habit" of davening more every day, despite the B"H busy lives we all lead. Tizki L'mitzvos and Kol HaKavod!`,
        name: `Meira`,
        description: `member of The Amida Army`
    },
    {
        quote: `Hi, I just wanted to share that I am at a work conference and I’m the only frum person here. Usually I work from home so I’m not in this environment every day, but today I was and I felt it - I felt different from everyone surrounding me. There were a few free minutes this afternoon and I decided to go to my hotel room and daven mincha before it got too late. Thank you for encouraging us to make davening shemoneh esrei a priority.`
    },
    {
        quote: `I want to say thank you for this incredible opportunity. I am a baal teshiva who for years has struggled with davening every day. I don't know much Hebrew and the English seemed very far away. I couldn't connect. I couldn't find the kavanah I was told that I would feel if I davened all the time. 

        But, like every other Jew on the planet, on October 7, the question of "what can I do" hit full force. I gave Tzedakah. I said tehillim. I did more learning and encouraged my kids to do more too. I did all the things that the rabbis said to do but it didn't seem like enough. However much I did, it felt like a drop in the bucket compared to those who were (are) displaced, those who are single parents as their husbands are on miluim, as those who were (are) in tzahal or who lost someone. 
        
        That feeling persisted until I read about the amidah army. It allowed me to feel like, during the few minutes a day that I daven, I am protecting a soldier from a bullet, a hostage from a moment of torture, a wife or child of a chayal from worry, or an innocent from getting hit by a rocket. I don't know if that is true on the ground but I have faith that it is. I can't say that I daven every day but I know that, thanks to this initiative, I have davened more in the last 6 months than the last 5 years.`,
        name: `Miraim`,
        description: `Toronto`
    },
    {
        quote: `A thought to share with the group…I hope it’s not too heavy…

        I believe that we women are strong. I believe that we can do hard things. I believe we need to believe we can do hard things. I think not enough of us believe we can. And not only can we but we have to keep at it. And yet we need to be so careful not to let our contribution come from a place of guilt- only from a place of responsibility. What I’ve found helpful at times is to close my eyes and take just a minute and imagine the spouse of a chayal. Or a mother of a hostage. I think a lot of us are afraid to go there and let ourselves think and feel for just a minute the terror these people are continuously going through. But, when I take just that one minute - and really feel with them- there is no guilt. There is pain. Pain for brothers and sisters I don’t know that pulling out my siddur is just something I have to keep doing for them. It’s hard. It’s so hard. But it’s my responsibility even if it’s hard. I can do hard things. We can do hard things. 5 minutes a day is something I can do even though it’s hard.
        
        Thanks for helping me keep at it.`,
        name: `Rivky`,
        description: `from Baltimore, MD`
    },
    {
        quote: `When I joined this initiative, I felt a lot of emotion after opening my siddur for the first real time in years. It was almost a gift in a way- a place to put all my emotions for what was going on. And then a few months went by and my passion faded and I’ve noticed I need to push myself more and more to keep at it. And it’s hard. And sometimes the constant struggle makes me feel sad- like- will this ever get easier for me?

        And then I thought of the chayalim. Away from their families. In a cold and dark place. Not great sleep. Lots of weapons. Danger. A lot of discomfort. And yet they do what they have to do despite all the lack of ease because they have a clear mission. They need to uproot the evil. And it’s not easy or comfortable doing that. 
        
        And I thought of this as I davened Shemona Esrei tonight. It wasn’t easy. I wanted to get into my pajamas, get into bed and plug into some podcast. But I pushed. And even while I davened it was hard. And yet- when I think of myself as truly on a battlefront of sorts- my difficulty is actually the thing that puts me right there on the front. It would be so nice if it was easier for me to daven. But I think the challenge and difficulty of it is what truly makes us all another type of warriors in this war too…`
    },
    {
        quote: `I am such a fan of Amida Army! I was sharing over with a friend about how it has changed my life and enabled me to get back into a habit of saying shemona esrei almost every day. It’s a lot having to do with pushing that big orange button that confirmed that I said it! It seems funny to say because of course I would want to say it for the hostages and chayalim, yet this orange button gives a satisfying experience when the numbers all increase by one. I see my one shemona esrai made a big difference!! Professionally, I do a lot of work related to behavioral economics or behavior change and wow wow wow, I am so amazed at how well you ladies made this experience to positively change my behavior (and my neshama)! Very soon we should be saying shemona esrei, singing, and dancing, praising Hashem for the release of the hostages and the success of the chayalim and welcoming Moshiach! Kol hakavod and a huge THANK YOU for starting the amida army!!`,
        description: `member of the Amida Army`
    }
];

const testimonials = [
    {
        title: 'Mr. Arky Staiman',
        subtitle: 'Chayal',
        filename: 'arky-staiman-II'
    },
    {
        title: 'Rabbi Yisrael Motzen',
        subtitle: 'Rabbi of Ner Tamid, Greenspring Valley synagogue, Baltimore, MD; serves as the Special Assistant to the EVPs of the Orthodox Union',
        filename: 'rabbi-yisrael-motzen'
    },
    {
        title: 'Rabbi Pinchos Gross',
        subtitle: 'Rav of Derech Chaim, Baltimore',
        filename: 'rabbi-pinchos-gross'
    },
    {
        title: 'Rabbi Elchanan Shoff',
        subtitle: 'Rabbi of Beis Knesses of Los Angeles',
        filename: 'rabbi-elchanan-shoff'
    },
    {
        title: 'Rabbi Ari Bensoussan',
        subtitle: 'LA Director of Chazak International',
        filename: 'rabbi-ari-bensoussan'
    },
    {
        title: 'Mrs. Rikki Ash',
        subtitle: 'Teacher at Stella K. Abraham High School for Girls in Hewlett, NY',
        filename: 'mrs-rikki-ash'
    },
    {
        title: 'Rabbi Aubrey Hersh',
        subtitle: 'Senior Lecturer and Project Director at JLE',
        filename: 'rabbi-aubrey-hersh'
    },
    {
        title: 'Rabbi Moshe Winter',
        subtitle: 'Rav of Tpheris Israel in Chesterfield, MO',
        filename: 'rabbi-moshe-winter'
    },
    {
        title: 'Rabbi Yisroel Motzen',
        subtitle: 'Rav of Ner Tamid in Baltimore, MD',
        filename: 'rabbi-yisroel-motzen'
    },
    {
        title: 'Rabbi Seidemann',
        subtitle: 'Rav of Kehilath B\'nai Torah, Baltimore MD',
        filename: 'rabbi-seidemann'
    },
    {
        title: 'Mrs. Esther Wein',
        subtitle: 'Noted lecturer, https://www.estherwein.com/',
        filename: 'mrs-esther-wein'
    },
    {
        title: 'Rabbi Menachem Tenenbaum',
        subtitle: 'Associate Regional Director of Central East NCSY and Author of Three Steps Forward',
        filename: 'rabbi-menachem-tenenbaum'
    },
    {
        title: 'Rabbi Gershon Eliezer Schaffel',
        subtitle: 'Rav of Young Israel of Skokie',
        filename: 'rabbi-gershon-eliezer-schaffel'
    },
    {
        title: 'Dr. David J. Lieberman, PhD',
        subtitle: 'Renowned author, psychotherapist and internationally recognized leader in the fields of human behavior and interpersonal relationships',
        filename: 'dr-david-j-lieberman'
    },
    {
        title: 'Rebbetzin Shira Smiles',
        subtitle: 'International lecturer, seminary teacher and author',
        filename: 'rebbetzin-shira-smiles'
    },
    {
        title: 'Mr. Arky Staiman',
        subtitle: 'IDF Soldier',
        filename: 'arky-staiman'
    },
    {
        title: 'Mr. Nachi Gordon',
        subtitle: 'Podcast host of Meaningful People Podcast',
        filename: 'nachi-gordon'
    },
    {
        title: 'Allyson from Ramat Bet Shemesh',
        subtitle: 'Mother of IDF Chayal',
        filename: 'allyson-from-ramat-bet-shemesh'
    },
    {
        title: 'Rabbi Menachem Nissel',
        subtitle: 'Senior Educator for NCSY, Senior Lecturer for Ner LeElef, Rosh Mesivta at Yeshivas Yishrei Lev, and widely acclaimed author',
        filename: 'rabbi-menachem-nissel'
    },
    {
        title: 'Rebbetzin Esti Hamilton',
        subtitle: 'Head of School at Shaarei Bina Torah Academy for Girls Hollywood, Florida',
        filename: 'rebbetzin-esti-hamilton'
    },
    {
        title: 'Rabbi Yitzchak Breitowitz',
        subtitle: 'Senior Lecturer at Ohr Somayach and Rav of Kehillos Ohr Somayach',
        filename: 'rabbi-yitzchak-breitowitz'
    },
    {
        title: 'Stacey from Ramat Bet Shemesh',
        subtitle: 'Mother of IDF Chayalim',
        filename: 'stacey-from-ramat-bet-shemesh'
    },
    {
        title: 'Mrs. Mindel Kassorla',
        subtitle: 'Seminary Teacher',
        filename: 'mindel-kassorla'
    },
    {
        title: 'Rabbi Yissocher Frand',
        subtitle: 'Maggid shiur at Yeshivas Ner Yisroel and noted author and speaker',
        filename: 'rabbi-yissocher-frand'
    },
    {
        title: 'Rabbi Moshe Hauer',
        subtitle: 'Executive Vice President of the OU',
        filename: 'rabbi-moshe-hauer'
    },
    {
        title: 'Mr. Charlie Harary',
        subtitle: 'Motivational Speaker',
        filename: 'charlie-harary'
    }
];

function timezoneGuess() {
    return Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
}
